/**
 * 批量添加查询参数到 URL
 * @param url 原始URL
 * @param params 参数对象
 * @returns 添加参数后的URL
 */
export function addQueryParams(url: string, params: Record<string, string>): string {
    try {
        const urlObj = new URL(url);
        Object.entries(params).forEach(([key, value]) => {
            urlObj.searchParams.set(key, value);
        });
        return urlObj.toString();
    } catch (error) {
        console.warn('Invalid URL format:', url);
        return url;
    }
}

/**
 * 移除URL中的查询参数
 * @param url 原始URL
 * @param param 要移除的参数名
 * @returns 移除参数后的URL
 */
export function removeQueryParam(url: string, param: string): string {
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(param);
        return urlObj.toString();
    } catch (error) {
        console.warn('Invalid URL format:', url);
        return url;
    }
}

/**
 * 获取URL中的查询参数值
 * @param url URL字符串
 * @param param 参数名
 * @returns 参数值，如果不存在则返回null
 */
export function getQueryParam(url: string, param: string): string | null {
    try {
        const urlObj = new URL(url);
        return urlObj.searchParams.get(param);
    } catch (error) {
        console.warn('Invalid URL format:', url);
        return null;
    }
}
